var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.33332L2 3.33332C1.87851 3.3337 1.75942 3.36721 1.65555 3.43024C1.55169 3.49327 1.46698 3.58343 1.41054 3.69102C1.3541 3.79862 1.32808 3.91956 1.33527 4.04084C1.34246 4.16213 1.38259 4.27915 1.45134 4.37932L7.45134 13.046C7.7 13.4053 8.29867 13.4053 8.548 13.046L14.548 4.37932C14.6175 4.27936 14.6582 4.16228 14.6658 4.04079C14.6733 3.91931 14.6475 3.79807 14.591 3.69025C14.5345 3.58243 14.4496 3.49216 14.3454 3.42923C14.2412 3.3663 14.1217 3.33313 14 3.33332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.d6e833e766444b69799434b720d51fce.svg";
export { ForwardRef as ReactComponent };